export function isNullOrUndefined(value: any): boolean {
    return value === null || value === undefined;
}

export function isEmptyValue(value: any): boolean {
    return isNullOrUndefined(value) || value === '' || (Array.isArray(value) && value.length === 0);
}